import { Link } from "react-router-dom";
import SEO from "../components/SEO/Seo";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

const ThankYou = () => {
  return (
    <>
      <SEO
        title="Thank You Page"
        description="We are committed to providing timely responses and personalized support to ensure you have a smooth and helpful experience. Whether you are exploring solutions, requesting a demo, or seeking more details, our goal is to assist you with clear communication and reliable guidance."
      />

      <Header />

      <section
        className="py-5 d-flex align-items-center"
        style={{ minHeight: "60vh", backgroundColor: "#ffffff" }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 text-center">
              <div className="card shadow-sm p-5 border-0">
                <h1 className="fw-bold text-success mb-3">🎉 Thank You!</h1>

                <p className="fs-5 text-muted mb-4">
                  Your request has been submitted successfully. Our team will
                  contact you shortly.
                </p>

                <div className="d-flex justify-content-center gap-3">
                  <Link to="/" className="btn btn-outline-primary">
                    Back to Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ThankYou;
